<div class="explore" [ngClass]="{'off': !showExplore || modalOpen, 'shift': headerOpen}">
    <div class="arrow" (click)="exploreArrowClick('left')" [ngClass]="{'disabled': noLeftArrow}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.03 27.47">
            <path d="M17 0L0 13.73l17 13.74 3.04-3.75-12.36-9.99 12.36-9.98L17 0z" />
        </svg>
    </div>
    <p>Explore</p>
    <div class="arrow right" (click)="exploreArrowClick('right')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.03 27.47">
            <path d="M17 0L0 13.73l17 13.74 3.04-3.75-12.36-9.99 12.36-9.98L17 0z" />
        </svg>
    </div>
</div>

<div
    class="hover-text main"
    [ngClass]="{'off': !hoverText.visible}"
    [style.top]="hoverText.top"
    [style.left]="hoverText.left"
>
    <div [innerHTML]="hoverText.text"></div>
</div>
<div
    class="hover-text alt"
    [ngClass]="{'off': !hoverTextAlt.visible}"
    [style.top]="hoverTextAlt.top"
    [style.left]="hoverTextAlt.left"
>
    <div [innerHTML]="hoverTextAlt.text"></div>
</div>

<div id="container" [ngClass]="{'shift': headerOpen}"></div>
